import React from 'react';
import { Typography, Paper, Stack } from '@mui/material';

const StaticMessageCards = ({ isMaximized }) => {
  const maxWidth = isMaximized ? 560 : 308;

  return (
    <>
      <Typography variant="h4" fontWeight={600}>
        Hello,
      </Typography>

      <Typography variant="h4" fontWeight={600} mb={4}>
        What would you like to know?
      </Typography>

      <Paper
        elevation={0}
        sx={{
          p: 2.5,
          mb: 1,
          backgroundColor: '#F6F6F6',
          borderRadius: 2,
          maxWidth,
          wordBreak: 'break-word',
        }}
      >
        Hi! I&apos;m E-Delivery AI Agent.
      </Paper>

      <Stack spacing={1}>
        <Paper
          elevation={0}
          sx={{
            p: 2.5,
            backgroundColor: '#F6F6F6',
            borderRadius: 2,
            maxWidth,
            wordBreak: 'break-word',
          }}
        >
          Need help with anything in the application? Whether it&apos;s fetching details, generating reports, or
          tracking progress, I&apos;ve got you covered.
        </Paper>

        {/* <Paper
          elevation={0}
          sx={{
            p: 2.5,
            backgroundColor: '#F6F6F6',
            borderRadius: 2,
            maxWidth: 304,
            wordBreak: 'break-word',
          }}
        >
          Enter your email to log in and start the conversation.
        </Paper> */}
      </Stack>
    </>
  );
};

export default StaticMessageCards;
